import type { Ranges } from 'api/System/types'
import { getDateKey } from 'data/utils'
import { moment } from 'locale'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import { FETCH_OWNERS, FETCH_OWNERS_DONE, FETCH_OWNERS_ERROR, FETCH_OWNERS_SUCCESS } from './constants'
import type { Owner, Owners as OwnersState } from './types'

interface ReducerAction extends Action {
  payload: {
    data: Owner[]
    dateCurrent: RequestDate
    dateCompared?: RequestDate | null
    errorCode?: number
    range: Ranges
  }
}

export default function Owners(state: OwnersState = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_OWNERS:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          errorCode: null,
          isLoading: true,
        },
      }
    case FETCH_OWNERS_DONE:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_OWNERS_ERROR:
      return {
        ...state,
        [getDateKey(payload)]: {
          errorCode: payload?.errorCode,
          isLoading: false,
        },
      }
    case FETCH_OWNERS_SUCCESS:
      return {
        ...state,
        [getDateKey(payload)]: {
          data: payload.data,
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    default:
      return state
  }
}
